import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
//import jsPDF from "jspdf";

import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";
import {
  TextField,
  Grid,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

//import ReactExport from "react-data-export";

import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
import encryptionService from "../../../services/encryptionService";

//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const Products = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "products";

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const [dataItems, setDataItems] = useState([]);

  const userId = UserInfo == 0 ? "" : UserInfo[0].id;
  const RoleItemGroupId = UserInfo == 0 ? "" : UserInfo[0].ItemGroupId;
  /*   const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);
 */

  const ProductGroup_List = JSON.parse(
    localStorage.getItem("ProductGroupList")
  );
  let All_Group_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All"]),
  };
  const ProductGroupList = [All_Group_label].concat(ProductGroup_List);
  const [currProductGroupId, setCurrProductGroupId] = useState(0);
  const [ProductCount, setProductCount] = useState(0);

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrProductGroupId(rowId);
  };

  let params = {
    menukey: menukey,
    action: "getDataList",
    ItemGroupId: currProductGroupId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };
  const { error, isError, data, refetch } = useQuery(
    [params],
    api.getProducts,
    {
      onSuccess: (data) => {
        localStorage.setItem("ProductDataNextPrev", JSON.stringify(data));

        setDataItems(data);
        setProductCount(data.length);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  /*   const { isLoading, error, isError, data, refetch } = useQuery(["products"],
    api.getProducts,
    {
      onSuccess: (data) => {
        
        localStorage.setItem(
          "ProductDataNextPrev",
          JSON.stringify(data)
        );

        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
    }
  ); */

  const { mutate } = useMutation(api.deleteProduct, {
    onSuccess: (data) => {
      if (data.status == 200) {
        api.getAllDropdown("TLDsItemlist").then((response) => {
          localStorage.setItem(
            "TLDsItemlist",
            JSON.stringify(response.datalist.TLDsItemlist)
          );
          localStorage.setItem(
            "TLDZeroIndexItem",
            JSON.stringify(response.datalist.TLDZeroIndexItem)
          );
        });

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
        refetch();
        queryClient.getQueriesData("products");
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=ProductsListExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&ItemGroupId=" +
        currProductGroupId +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;

    row._row.parent.rows.forEach((rowss, i) => {
      if (row._row.data.id == rowss.data.id) {
        localStorage.setItem("ProductDataIndex", JSON.stringify(i));

        editProduct(rowData);
        return;
      }
    });

    // editProduct(rowData);
  };

  function RowInputData(props: any, type = null) {
    const rowData = props.cell._cell.row.data;
    let fieldName = props.field;
    let fieldType = props.fieldType;
    let labelName = props.labelName;
    let dropDownKey = props.dropDownKey;

    switch (fieldType) {
      case "check-box":
        return rowData.type == "bKeyItem" ? (
          <></>
        ) : (
          <Checkbox
            color="primary"
            checked={!!rowData[fieldName]}
            name={fieldName}
            value={rowData[fieldName]}
          />
        );
        break;

      default:
        return <></>;
        break;
    }
    return <></>;
  }

  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: "5%",
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "productCode",
      width: 115,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "productName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Short Name"]),
      field: "ShortName",
      headerFilter: true,
      width: 220,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Type"]),
      field: "ProductTypeName",
      headerFilter: false,
      width: 120,
      /* formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        
        if(value === 1){
          return t(DispensingLanguage[lan][menukey]["Drug Non ARV"]);
        }else if(value === 2){
          return t(DispensingLanguage[lan][menukey]["Medical Supply"]);
        }else if(value === 3){
          return t(DispensingLanguage[lan][menukey]["Others"]);
        }else if(value === 4){
          return t(DispensingLanguage[lan][menukey]["OI Medicine"]);
        }else{
          return t(DispensingLanguage[lan][menukey]["Drug"]);
        }
        
        //return value == 0 ? "" : Number(value).toLocaleString();
      }, */
    },
    {
      title: t(DispensingLanguage[lan][menukey]["ICN"]),
      field: "icn",
      width: 90,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["ECN"]),
      field: "ecn",
      width: 80,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["NSN"]),
      field: "nsn",
      width: 90,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Pack Cost (CFA)"]),
      field: "price",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      formatter: "money",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Key Product"]),
      field: "bKeyItem",
      hozAlign: "center",
      vertAlign: "middle",
      headerHozAlign: "center",
      width: 90,
      headerSort: true,
      formatter: reactFormatter(
        <RowInputData
          labelName="bKeyItem"
          field="bKeyItem"
          fieldType="check-box"
        />
      ),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      width: 100,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editProduct = (data) => {
    let route = `products/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteProduct = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Product!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        mutate(data.id);
      }
    });
  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              dataItems.forEach((row, i) => {
                if (rowData.id == row.id) {
                  localStorage.setItem("ProductDataIndex", JSON.stringify(i));
                  editProduct(rowData);
                  return;
                }
              });

              // editProduct(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              dataItems.forEach((row, i) => {
                if (rowData.id == row.id) {
                  localStorage.setItem("ProductDataIndex", JSON.stringify(i));
                  editProduct(rowData);
                  return;
                }
              });

              // editProduct(rowData);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deleteProduct(rowData);
            }}
          />
        </>
      );
    /*  return (
      <>
        <Edit
          onClick={() => {

            dataItems.forEach((row,i) => {
              if(rowData.id==row.id)
              {
                localStorage.setItem(
                  "ProductDataIndex",
                  JSON.stringify(i)
                );
                editProduct(rowData);
                return;
              } 
            });  

            // editProduct(rowData);
          }}
        />
        <DeleteOutline
          onClick={() => {
            deleteProduct(rowData);
          }}
        />
      </>
    ); */
  }

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Product"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={8}>
                <Grid container spacing={1}>
                  <Grid item xs={4} sm={4}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="ProductGroupList"
                        disableClearable
                        disabled={userId == 1 ? false : true}
                        options={ProductGroupList}
                        onChange={(event, newValue) =>
                          handleProductGroupChange(event, newValue)
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={
                          (ProductGroupList.find(
                              (productGroupList) =>
                                productGroupList.id == currProductGroupId
                            ) ?? null)
                        }
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Product Group"]
                            }
                            variant="standard"
                            hiddenLabel
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6}>
                    <div className="float-end marginTop10">
                      <h4 className="FontStyle">
                        {DispensingLanguage[lan][menukey]["Total Product"] +
                          ": " +
                          ProductCount}
                      </h4>
                    </div>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!permissionType}
                        color="info"
                        className="me-2"
                        onClick={() => {
                          props.history.push("/products/add");
                        }}
                      >
                        {DispensingLanguage[lan][menukey]["Add Product"]}
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("print")}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("excel")}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height={450}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
              options={{
                groupBy: "GroupName",
                columnCalcs: "both",
              }}
              //initialSort={[{ column: "GroupName", dir: "desc" }]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
